import { ethers } from 'ethers';

export const formatUSDT = (value, decimals = 2) => {
  if (!value) return '0.00';
  try {
    const formatted = ethers.utils.formatUnits(value.toString(), 18);
    const num = parseFloat(formatted);
    if (num === 0) return '0.00';
    if (num < 0.01) return '< 0.01';
    return num.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  } catch (e) {
    return '0.00';
  }
};

export const parseUSDT = (value) => {
  try {
    return ethers.utils.parseUnits(value.toString(), 18);
  } catch (e) {
    return ethers.BigNumber.from(0);
  }
};

export const shortAddress = (addr) => {
  if (!addr) return '';
  return `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`;
};

export const formatTimestamp = (ts) => {
  if (!ts) return '-';
  const n = Number(ts.toString());
  if (n === 0) return '-';
  const date = new Date(n * 1000);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatTimeRemaining = (seconds) => {
  const s = Number(seconds.toString());
  if (s <= 0) return 'Matured';
  const days = Math.floor(s / 86400);
  const hours = Math.floor((s % 86400) / 3600);
  const mins = Math.floor((s % 3600) / 60);
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${mins}m`;
  return `${mins}m`;
};

export const bpsToPercent = (bps) => {
  const n = Number(bps.toString());
  return (n / 100).toFixed(2);
};

// Convert a percentage string (e.g. "10", "0.6") to basis points integer.
// "10" -> 1000, "0.6" -> 60, "100" -> 10000
export const pctToBps = (pct) => {
  const n = parseFloat(pct);
  if (isNaN(n) || n < 0) return 0;
  return Math.round(n * 100);
};

export const percentProgress = (current, max) => {
  try {
    const c = parseFloat(ethers.utils.formatUnits(current.toString(), 18));
    const m = parseFloat(ethers.utils.formatUnits(max.toString(), 18));
    if (m === 0) return 0;
    return Math.min(100, (c / m) * 100);
  } catch (e) {
    return 0;
  }
};

export const copyToClipboard = async (text) => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    return true;
  } catch (e) {
    return false;
  }
};
